import * as React from "react";
import { SVGProps, memo } from "react";

const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.125 10a8.125 8.125 0 1 1-16.25 0 8.125 8.125 0 0 1 16.25 0Zm-7.188-4.063a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM10 7.97c.431 0 .781.35.781.781v4.688a.781.781 0 1 1-1.562 0V8.75c0-.431.35-.781.781-.781Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgInfo);

export default Memo;
